import { type VariantProps } from 'class-variance-authority';

import type { User } from 'src/features/auth';
import type { badgeVariants } from 'src/registry/ui/Badge';

type BadgeTheme = Exclude<VariantProps<typeof badgeVariants>['theme'], null | undefined>;

enum ALLOWED_DAYS {
    monday = 'monday',
    tuesday = 'tuesday',
    wednesday = 'wednesday',
    thursday = 'thursday',
    friday = 'friday',
    saturday = 'saturday',
    sunday = 'sunday',
}

enum MEMBERSHIP_GROUP_MEMBER_ACCESS_LEVEL {
    ADMIN = 'admin',
    MEMBER = 'member',
    GUEST = 'guest',
}

interface MembershipGroupMember {
    id: string;
    user?: User;
    invitation?: string;
    membership_group: number;
    access_level: MEMBERSHIP_GROUP_MEMBER_ACCESS_LEVEL;
    updated_at: string;
    created_at: string;
}

interface MembershipGroupCardTag {
    id: string;
    membership_group: number;
    is_global: boolean;
    text: string;
    theme: BadgeTheme;
    updated_at: string;
    created_at: string;
}

interface CardTag {
    id: string;
    card_tag: MembershipGroupCardTag;
    card_id: number;
}

interface MembershipGroupCard {
    membership_group_id: number;
    number: string;
    tags: CardTag[];
    id: number;
    description: string | null;
}

interface MembershipGroup {
    id: number;
    name: string;
    owner_name: string;
    owner_id: number;
    valid_until: string; // ISO 8601 date string
    valid_from: string; // ISO 8601 date string
    allowed_parkings: string[];
    allowed_points: string[];
    allowed_days: ALLOWED_DAYS[];
    allowed_hours_start: string; // HH:MM:SS format
    allowed_hours_end: string; // HH:MM:SS format
    allowed_parking_places: number;
    points_groups: string[];
    // A list of the numbers of MembershipCards, that are inside the group
    // included only when we retrieve the group or send it to the backend
    group_members?: string[];
    member_login_username: string;
    member_login_password: string;
    reserve_place: boolean;
    description: string | null;
    in_parking: boolean;
}

enum VEHICLE_LAYOUT {
    GRID = 'GRID',
    TABLE = 'TABLE',
}

export type {
    MembershipGroupCard,
    MembershipGroup,
    MembershipGroupCardTag,
    MembershipGroupMember,
    CardTag,
    BadgeTheme,
};
export { ALLOWED_DAYS, MEMBERSHIP_GROUP_MEMBER_ACCESS_LEVEL, VEHICLE_LAYOUT };
